(function(){
 var ROOT='.bundle-save-block-bundle_addons';
 function boxes(){ var r=document.querySelector(ROOT); if(!r) return []; return [].slice.call(r.querySelectorAll('input[type=checkbox]')).filter(function(c){return /^bundle_product_/.test(c.name||'')}); }
 function currentVariant(){ var f=document.querySelector('form[action*=cart] input[name=id]'); return f?String(f.value):''; }
 var PF0=document.querySelector('form.product-buy-form-pdp input[name="product-id"]')||document.querySelector('form[action*="cart/add"] input[name="product-id"]');
 var PAGE_PRODUCT=PF0?String(PF0.value):'';
 function pageProduct(){
  if(PAGE_PRODUCT) return PAGE_PRODUCT;
  try{ var m=window.ShopifyAnalytics&&window.ShopifyAnalytics.meta&&window.ShopifyAnalytics.meta.product; if(m&&m.id) return String(m.id); }catch(_){}
  return '';
 }

 /* --- Frequently-bought-together add-ons (the memory card) travel in the SAME /cart/add request
        as the camera (2026-10-10). For the one submit this click starts, extra items[] fields are put
        into the product form after the camera's own fields (camera first), and taken out again right
        after. One request: a camera that can't be added (sold out, 422) no longer leaves the card in
        the cart on its own. With every item in stock the cart ends up exactly as before. --- */
 var XVK='xv-fbt-items';
 function clearInjected(form){
  var c=form.querySelector('.'+XVK); if(c&&c.parentNode) c.parentNode.removeChild(c);
  [].slice.call(document.querySelectorAll('[data-xv-off]')).forEach(function(el){ el.disabled=el.getAttribute('data-xv-off')==='1'; el.removeAttribute('data-xv-off'); });
 }
 function hid(c,name,val){ var i=document.createElement('input'); i.type='hidden'; i.name=name; i.value=String(val); c.appendChild(i); }
 function inject(form,items){
  var els=[].slice.call(form.elements||[]), max=-1, idEl=null, file=false;
  els.forEach(function(el){
   var m=/^items\[(\d+)\]/.exec(el.name||''); if(m&&!el.disabled) max=Math.max(max,parseInt(m[1],10));
   if(el.name==='id'&&!el.disabled&&!idEl) idEl=el;
   if(el.type==='file'&&/^properties\[/.test(el.name||'')) file=true;
  });
  var c=document.createElement('div'); c.className=XVK; c.hidden=true;
  if(max<0){
   /* single-id form: the camera becomes items[0] so both lines go in one request */
   if(!idEl||!idEl.value||file) return false;
   var q='1', plan='', props=[];
   els.forEach(function(el){
    if(el.disabled||!el.name) return;
    if((el.type==='checkbox'||el.type==='radio')&&!el.checked) return;
    if(el.name==='quantity'){ if(el.value) q=el.value; return; }
    if(el.name==='selling_plan'){ if(el.value) plan=el.value; return; }
    var p=/^properties\[(.+)\]$/.exec(el.name); if(p) props.push([p[1],el.value]);
   });
   hid(c,'items[0][id]',idEl.value); hid(c,'items[0][quantity]',q);
   if(plan) hid(c,'items[0][selling_plan]',plan);
   props.forEach(function(p){ hid(c,'items[0][properties]['+p[0]+']',p[1]); });
   els.forEach(function(el){ if(el.name==='id'||el.name==='quantity'||/^properties\[/.test(el.name||'')){ el.setAttribute('data-xv-off',el.disabled?'1':'0'); el.disabled=true; } });
   max=0;
  }
  items.forEach(function(it,k){ hid(c,'items['+(max+1+k)+'][id]',it.id); hid(c,'items['+(max+1+k)+'][quantity]',it.quantity); });
  form.appendChild(c);
  return true;
 }

 /* --- After an add: Shopify's own error text is shown by product-form.js in
        .product-form__error-message-wrapper (snippets/product-info.liquid). Here: a request that
        ends with no reply at all (network) gets a plain message, and if an add-on was sent with a
        camera that failed, any add-on left in the cart without the camera is taken out again. --- */
 var NETMSG='Sorry, this could not be added to your cart. Please check your connection and try again.';
 var watching=null;
 function showError(form,msg){
  var pf=form.closest('product-form')||form.parentNode; if(!pf) return;
  var w=pf.querySelector('.product-form__error-message-wrapper'); if(!w) return;
  var m=w.querySelector('.product-form__error-message'); if(m) m.textContent=msg;
  w.hidden=false;
 }
 function undoAddOns(items){
  var pid=pageProduct();
  if(!pid||!items||!items.length) return;
  var want={}; items.forEach(function(it){ want[String(it.id)]=(want[String(it.id)]||0)+(parseInt(it.quantity,10)||1); });
  fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(cart){
   if(!cart||!cart.items) return;
   var hasCamera=cart.items.some(function(li){ return String(li.product_id)===pid; });
   if(hasCamera) return;
   var upd={}, any=false;
   cart.items.forEach(function(li){ var v=String(li.variant_id); if(want[v]){ var take=Math.min(want[v],li.quantity); want[v]-=take; upd[v]=(upd[v]===undefined?li.quantity:upd[v])-take; any=true; } });
   if(!any) return;
   return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:upd})});
  }).catch(function(){});
 }
 function watch(form,btn,items){
  if(watching) watching.stop();
  var w={done:false,started:false,offs:[],mo:null,t:null};
  w.stop=function(){ if(w.done) return; w.done=true; w.offs.forEach(function(f){ try{f()}catch(_){} }); if(w.mo) w.mo.disconnect(); clearTimeout(w.t); if(watching===w) watching=null; };
  watching=w;
  var ev=window.PUB_SUB_EVENTS;
  if(typeof window.subscribe==='function'&&ev){
   w.offs.push(window.subscribe(ev.cartUpdate,function(d){ if(!d||d.source==='product-form') w.stop(); }));
   w.offs.push(window.subscribe(ev.cartError,function(d){ if(d&&d.source&&d.source!=='product-form') return; w.stop(); undoAddOns(items); }));
  }
  if(btn&&window.MutationObserver){
   w.mo=new MutationObserver(function(){
    if(w.done) return;
    if(btn.classList.contains('loading')){ w.started=true; return; }
    if(w.started){ w.stop(); showError(form,NETMSG); undoAddOns(items); }
   });
   w.mo.observe(btn,{attributes:true,attributeFilter:['class']});
  }
  w.t=setTimeout(function(){ if(!w.started) w.stop(); },3000);
 }

 document.addEventListener('click',function(e){
  var t=e.target; if(!t||!t.closest) return;
  var btn=t.closest('button[name=add]');
  if(!btn) return; if(btn.closest(ROOT)) return;
  var form=btn.form||btn.closest('form');
  if(!form||!/cart\/add/.test(form.getAttribute('action')||'')) return;
  if(btn.classList.contains('loading')||btn.getAttribute('aria-disabled')==='true') return;
  clearInjected(form);
  var cur=currentVariant(); var items=[];
  boxes().forEach(function(cb){ if(!cb.checked||!cb.value) return; if(String(cb.value)===cur) return; items.push({id:parseInt(cb.value,10),quantity:1}); });
  if(items.length&&!inject(form,items)) items=[];
  watch(form,btn,items);
  if(items.length) setTimeout(function(){ clearInjected(form); },0);
 },true);

 /* --- Sticky bar button (2026-10-10): the templates now use the valid "scroll_to_section"
        behaviour (it used to fall through to adding product.variants.first). When the page has a
        visible buy button, bring that button itself into view, so the colour and pack picked
        above it stay the ones that are bought; otherwise the theme's own section scroll runs. --- */
 document.addEventListener('click',function(e){
  var t=e.target; if(!t||!t.closest) return;
  var s=t.closest('.sticky-add-to-cart__button[data-button-behavior="scroll_to_section"]');
  if(!s) return;
  var add=document.querySelector('form.product-buy-form-pdp button[name=add]')||document.querySelector('form[action*="cart/add"] button[name=add]');
  if(!add||!add.getClientRects().length) return;
  e.preventDefault(); e.stopImmediatePropagation();
  var still=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  try{ add.scrollIntoView({behavior:still?'auto':'smooth',block:'center'}); }catch(_){ add.scrollIntoView(); }
  try{ add.focus({preventScroll:true}); }catch(_){}
 },true);

 /* --- Bundle defaults: never two identical units by accident.
        Each option suffix carries its own preference order; a preference is only
        applied if the select actually offers that value, so pages without the
        option are untouched. A sold-out value (disabled option) is never picked:
        the unit then gets the first in-stock value not already used in that pack.
        Runs only until the buyer touches a control. --- */
 var PREFS={ color:['White','Blue','Black','Grey'], design:['Poodle','Westie','Sitting Cat','Lounging Cat'], style:['Sunset Glow (Wireless)','Twilight City (Wired)'] };
 var applied=false, touched=false;
 document.addEventListener('change',function(e){
  var el=e.target; if(!el) return;
  var key=el.id||el.name||'';
  if(/^option-\d+-\d+-/.test(key) && applied) touched=true;
 },true);
 function packValues(pack,sfx,skip){
  var out=[];
  for(var u=1;u<=4;u++){ if(u===skip) continue; var o=document.getElementById('option-'+pack+'-'+u+'-'+sfx); if(o&&o.tagName==='SELECT') out.push(o.value); }
  return out;
 }
 function setControl(id,want,pack,unit,sfx){
  var el=document.getElementById(id)||document.querySelector('[name="'+id+'"]');
  if(!el) return false;
  if(el.tagName==='SELECT'){
   var opts=[].slice.call(el.options);
   var ok=opts.some(function(o){return o.value===want&&!o.disabled});
   if(!ok&&opts.some(function(o){return o.value===want})){
    var used=packValues(pack,sfx,unit);
    var alt=opts.filter(function(o){return !o.disabled&&used.indexOf(o.value)<0})[0];
    if(alt){ want=alt.value; ok=true; }
   }
   if(ok&&el.value!==want){ el.value=want; el.dispatchEvent(new Event('change',{bubbles:true})); }
   return true;
  }
  var radios=document.querySelectorAll('input[name="'+id+'"]');
  if(radios.length){
   var target=[].slice.call(radios).filter(function(r){return r.value===want&&!r.disabled})[0];
   if(target&&!target.checked) target.click();
   return true;
  }
  return false;
 }
 function presetBundle(){
  if(applied||touched) return;
  var found=false;
  Object.keys(PREFS).forEach(function(sfx){
   var prefs=PREFS[sfx];
   [2,3,4].forEach(function(pack){
    for(var u=2;u<=4;u++){
     var want=prefs[u-1]; if(!want) continue;
     if(setControl('option-'+pack+'-'+u+'-'+sfx,want,pack,u,sfx)) found=true;
    }
   });
  });
  if(found) applied=true;
 }
 [600,1400,2600,4000].forEach(function(ms){ setTimeout(presetBundle,ms); });
 document.addEventListener('click',function(e){
  var t=e.target; if(t&&t.closest&&t.closest('[class*=quantity-break]')){ setTimeout(presetBundle,250); }
 },true);

 /* --- Dispatch countdown: time left today, so ordering now vs tomorrow really does
        move the dispatch date. No fake deadline, it just counts to local midnight. --- */
 function tickCountdown(){
  var el=document.getElementById('xv-cd');
  if(!el) return;
  var now=new Date();
  var end=new Date(now.getFullYear(),now.getMonth(),now.getDate()+1,0,0,0,0);
  var s=Math.max(0,Math.floor((end-now)/1000));
  var h=Math.floor(s/3600), m=Math.floor((s%3600)/60);
  el.textContent=h+' hrs '+(m<10?'0':'')+m+' min';
 }
 tickCountdown(); setInterval(tickCountdown,30000);

 /* --- SAVE chip follows the headline price. Tier pickers rewrite the price and compare-at
        but not the chip, so a 2-pack showed the single-camera "SAVE 50%". Recompute the % from
        the two numbers on screen, same rounding as the Liquid price block. --- */
 function xvNum(el){ var m=(el&&el.textContent||'').replace(/,/g,'').match(/\d+(?:\.\d+)?/); return m?parseFloat(m[0]):0; }
 function xvChip(){
  var box=document.querySelector('.shop-product-price-container'); if(!box) return;
  var p=box.querySelector('.shop-product-price-block'), c=box.querySelector('.shop-compare-price'), s=box.querySelector('.shop-save-price');
  if(!p||!c||!s) return;
  var pv=xvNum(p), cv=xvNum(c); if(!pv||!cv||cv<=pv) return;
  var pct=Math.round((cv-pv)*100/cv);
  var w=document.createTreeWalker(s,NodeFilter.SHOW_TEXT,null), n;
  while((n=w.nextNode())){
   if(n.parentNode&&n.parentNode.nodeName==='STYLE') continue;
   if(/\d+\s*%/.test(n.nodeValue)){ var v=n.nodeValue.replace(/\d+(\s*%)/,pct+'$1'); if(v!==n.nodeValue) n.nodeValue=v; return; }
  }
 }
 (function(){
  var box=document.querySelector('.shop-product-price-container'); if(!box) return;
  var t=null;
  new MutationObserver(function(){ clearTimeout(t); t=setTimeout(xvChip,30); }).observe(box,{subtree:true,childList:true,characterData:true});
  xvChip();
 })();

 /* --- Flatten anything the theme paints with a gradient or shadow inline. --- */
 function pol(){
  var a=document.querySelectorAll('.shop-add-to-cart-button, .sticky-add-to-cart__button');
  for(var i=0;i<a.length;i++){
   a[i].style.setProperty('background-image','none','important');
   a[i].style.setProperty('background-color','#111111','important');
   a[i].style.setProperty('border-radius','12px','important');
   a[i].style.setProperty('box-shadow','none','important');
  }
 }
 pol(); setTimeout(pol,700); setTimeout(pol,1800);

 /* --- Sync Simple Variant Picker choice into Unit #1 of multi-pack bundles & keep headline price per-unit --- */
 document.addEventListener('change',function(e){
  var el=e.target; if(!el||!el.classList) return;
  if(el.classList.contains('simple-variant-picker__radio')||el.classList.contains('simple-variant-picker__select')){
   var val=el.value; if(!val) return;
   ['color','design','style'].forEach(function(sfx){
    [2,3,4].forEach(function(pack){
     var sel=document.getElementById('option-'+pack+'-1-'+sfx);
     if(sel&&sel.tagName==='SELECT'&&!touched){
      var has=[].slice.call(sel.options).some(function(o){return o.value===val&&!o.disabled;});
      if(has&&sel.value!==val){ sel.value=val; sel.dispatchEvent(new Event('change',{bubbles:true})); }
     }
    });
   });
  }
 },true);
})();
